import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { VehicleLoader } from '../../common_components/Loader/Index';
import { bindActionCreators } from 'redux';
import * as homePageActions from '../../actions/homePageActions';
import NewVehicleDetailsCard from '../../common_components/Common/NewVehicleDetailsCard';
import { BiSort } from 'react-icons/bi';
import { FiFilter } from 'react-icons/fi';
import { isMobile, isDesktop } from 'react-device-detect';
import { Modal, ModalHeader } from 'reactstrap';
import { closeIcon } from '../../common_components/CommonFields';
import MobileFilter from './components/MobileFilter';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Pagination } from 'antd';
import { Form } from 'react-bootstrap';
import { useRouter } from 'next/router';
library.add(faAngleDown);
import dynamic from 'next/dynamic';
import NoSSRComponent from './components/ProductFilters';

export default function Index() {
  const CommonParentSection = dynamic(() => import('../LandingPage/components/CommonParentSection'))
  const HomeUpcomingVehicleCard = dynamic(() => import('../LandingPage/components/HomeUpcomingVehicleCard'))
  const NewsSectionCard = dynamic(() => import('../LandingPage/components/NewsSectionCard'))
  const BlogSection = dynamic(() => import('../LandingPage/components/BlogSection'))

  const VehicleCompareCard = dynamic(() => import('../LandingPage/components/VehicleCompareCard'))
  const FaqSection = dynamic(() => import('../LandingPage/components/HomePageFaqSection'))
  const Popularimages = dynamic(() => import('./components/Popularimages'))
  const RunningCostCalculator = dynamic(() => import('./components/RunningCalculator'))

  const CompareModal = dynamic(
    () => import('../LandingPage/components/AddToCompare'),
    {
      ssr: false,
    }
  );
  const dispatch = useDispatch();
  const homeData = JSON.parse(sessionStorage.getItem('homepageFilterData'));
  /* const homeData = getCookie('homepageFilterData'); */
  const [openCompareModal, setOpenCompareModal] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [routerReady, setRouterReady] = useState(false)
  const [loader, setLoader] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openfilter, setOpenFilter] = useState(false);
  const [filterLoader, setFilterLoader] = useState(true);
  const [fetchVehicleData, setFetchVehicleData] = useState(true);
  const [pageChanges, setPageChages] = useState(false);


  const orderByOpt = {
    1: 1,
    2: 3,
    3: 4,
    4: 5
  };

  const router = useRouter()
  const { type } = router.query

  const [orderby, setOrderby] = useState(6);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setTimeout(function () {
      if (type == 'popular') {
        setOrderby(6)
      } else if (type == 'latest') {
        setOrderby(7)
      } else {
        setOrderby(6)
      }
    }, 1000, type)

  }, []);

  useEffect(() => {
    if (!routerReady && isMobile) {
      let value = [];
      if (router.pathname === '/electric-vehicles') {
        value = ['1', '2', '10', '20']
      }
      if (router.pathname === '/electric-two-wheelers') {
        value = ['1', '2']
      }
      if (router.pathname === '/electric-commercial-vehicles') {
        value = ['20']
      }
      if (router.pathname === '/upcoming') {
        value = ['2']
      }

      if (router.pathname === '/electric-scooters') {
        value = ['2']
      }

      if (router.pathname === '/electric-bikes') {
        value = ['1']
      }
      if (router.pathname === '/electric-cars') {
        value = ['10']
      }
      setRouterReady(true)
    }
  }, []);


  const [filterby, setFilterBy] = useState(3);
  // const [loadedFirst, setLoadedFirst] = useState(false);
  const { getFilteredVehicles, AddFilterData, getVehicleRange, getFilteredCompanies } = bindActionCreators(homePageActions, dispatch);
  const { filterData, filteredVehicles, vehicleLoading, waitingPeriod, isFilter, comparevehicles, faqList } = useSelector((state) => state.home);
  const { upcomingList, loading } = useSelector((state) => state.upcoming);
  const [allVehicleData, setAllVehicleData] = useState([]);

  const onSelectIdValue = (e, data) => {
    if (selectedId.includes(e.target.id) && selectedId.length <= 3) {
      setSelectedId(selectedId.filter((tool) => tool !== e.target.id));
    } else if (selectedId.length < 3) {
      setSelectedId([...selectedId, e.target.id]); // or push
    } else {
      toast.error("You can't select more than 3");
    }
    if (selectedArr.includes(data) && selectedArr.length <= 3) {
      setSelectedArr(selectedArr.filter((tool) => tool !== data));
    } else if (selectedArr.length < 3) {
      setSelectedArr([...selectedArr, data]); // or push
    }
  };

  const onRemove = (data) => {
    setSelectedId(selectedId.filter((tool) => tool !== data._id));
    setSelectedArr(selectedArr.filter((tool) => tool !== data));
  };

  // useEffect(() => {
  //   getVehicleRange();
  // }, []);


  useEffect(() => {
    setAllVehicleData(filteredVehicles.docs)
    setFilterLoader(false)
    return (() => {
      setAllVehicleData([])
    })
  }, [filteredVehicles])



  useEffect(() => {
    setOpenCompareModal(selectedArr.length > 0 ? true : false);
  }, [selectedArr, selectedId]);

  const TriggerLoader = () => {
    setAllVehicleData([])
    setFilterLoader(true)
  }


  const handleChange = (e) => {
    // console.log(e.target.value)
    const value = e.target.value;
    setOrderby(value);
    // setOpenModal(false);
  };

  useEffect(() => {
    if (isMobile) {
      AddFilterData({ ...filterData, order_by: orderby, page: pageChanges ? page : 1 })
      setAllVehicleData([])
      setFilterLoader(true)
      setPageChages(false)
    }
  }, [orderby, page, router.pathname])

  // useEffect(() => {
  //   if (isMobile && router.pathname === "/upcoming") {
  //     const updatedFilterData = { ...filterData, filter_by: 2, order_by: orderby, page: pageChanges ? page : 1 };
  //     AddFilterData(updatedFilterData)
  //   }
  // }, [router.pathname])


  useEffect(() => {
    if (isMobile) {
      window.scrollTo(0, 0)
      if (router.pathname === "/upcoming") {
        const updatedFilterData = { ...filterData, filter_by: 2, order_by: orderby, page: pageChanges ? page : 1 };
        getFilteredVehicles(updatedFilterData);
      } else {
        getFilteredVehicles(filterData)
      }
      getFilteredCompanies(filterData)
      localStorage.setItem('filterData', JSON.stringify(filterData))
    }
  }, [filterData])

  const handleSortby = (e) => {
    setOrderby(e.value);
  };


  const options = [];
  options.push({
    label: <div className='text-start'>Low to high price</div>,
    value: 1,
  });
  options.push({
    label: <div className='text-start'>High to Low price</div>,
    value: 2,
  });
  options.push({
    label: <div className='text-start'>Top speed</div>,
    value: 3,
  });
  options.push({
    label: <div className='text-start'>Range</div>,
    value: 4,
  });
  options.push({
    label: <div className='text-start'>Waiting Period</div>,
    value: 5,
  });
  options.push({
    label: <div className='text-start'>Popular</div>,
    value: 6,
  });
  options.push({
    label: <div className='text-start'>Latest</div>,
    value: 7,
  });

  const modifyOptions = [
    { label: <div className='text-start'>Available</div>, value: 1 },
    { label: <div className='text-start'>Upcoming</div>, value: 2 },
    { label: <div className='text-start'>Both</div>, value: 3 },
  ];

  const filteredOptions = router.pathname === '/upcoming'
    ? modifyOptions.filter(option => option.value === 2) // Only show "Upcoming" if on /upcoming page
    : modifyOptions; // Show all options on other pages

  // const modifyOptions = [];
  // modifyOptions.push({
  //   label: <div className='text-start'>Available</div>,
  //   value: 1,
  // });
  // modifyOptions.push({
  //   label: <div className='text-start'>Upcoming</div>,
  //   value: 2,
  // });
  // modifyOptions.push({
  //   label: <div className='text-start'>Both</div>,
  //   value: 3,
  // });

  const customCityStyle = {
    control: (base, state) => ({
      ...base,
      height: 20,
      minHeight: 32,
      marginBottom: 10,
    }),
    placeholder(base, state) {
      return {
        ...base,
        display: state.isFocused && 'none',
        paddingBottom: '2px',
      };
    },
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        backgroundColor: isDisabled && 'white',
        color: isDisabled ? '#929292' : 'black',
        fontSize: isDisabled ? '12px' : '14px',
        '&:hover': {
          backgroundColor: isDisabled ? 'white' : '#4A90E4',
          color: isDisabled ? '#929292' : 'white',
        },
        cursor: isDisabled ? 'not-allowed' : 'default',
        fontWeight: isDisabled ? '500' : 'normal',
      };
    },
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      color: 'black',
      paddingRight: '15px',
      paddingBottom: '10px',
      // transform: state.isFocused ? 'rotate(0deg)' : 'rotate(-90deg)',
    }),
  };

  const CaretDownIcon = () => {
    return <FontAwesomeIcon icon='angle-down' />;
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  useEffect(() => {
    // Check if the page is '/upcoming' and set filterby to 2
    if (router.pathname === '/upcoming') {
      setFilterBy(2);
    }
  }, [router.pathname]);

  const handlefilterby = (e) => {

    if (e.value === 2 && router.pathname !== '/upcoming') {
      router.push('/upcoming');
      setFetchVehicleData(false);
      return;
    }

    const value = e.value;
    setFilterBy(value);
    setFetchVehicleData(false);


  };

  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a>Previous</a>;
    }
    if (type === 'next') {
      return <a>Next</a>;
    }
    return originalElement;
  };

  useEffect(() => {
    setTimeout(() => {
      setOpenFilter(true);
      setTimeout(() => {
        setOpenFilter(false)
      }, 100)
    }, 500)
  }, [])

  return (
    <section className='new-bg-clr'>
      <section>
        <div className=' vehicle-title d-flex align-items-center justify-content-center flex-column'>
          <h1 className='my-0 fs-4'>
            {
              router.pathname === '/electric-scooters' ? 'Electric Scooters' :
                router.pathname === '/electric-bikes' ? 'Electric Bikes' :
                  router.pathname === '/electric-cars' ? 'Electric Cars' :
                    router.pathname === '/electric-two-wheelers' ? 'Electric Two Wheelers' :
                      router.pathname === '/upcoming' ? 'Upcoming Electric Vehicles' :
                        router.pathname === '/electric-commercial-vehicles' ? "Electric Commercial Vehicles" : "EV's for you"
            }
          </h1>
          <hr></hr>
        </div>
      </section>


      <section className='py-5 new-bg-clr container'>

        <div className='row'>
          {isDesktop && (
            <div className='new-sort text-end' style={{ paddingRight: '22px' }}>
              <span style={{ fontSize: '18px', fontWeight: '500' }}>
                Modify your results{' '}
              </span>
              <span className='col-2 '>
                <Select
                  placeholder='Select any option'
                  styles={customCityStyle}
                  value={filteredOptions.find((ele) => ele.value === filterby) || ''}
                  noOptionsMessage={() => 'loading...'}
                  onChange={(e) => handlefilterby(e)}
                  components={{
                    DropdownIndicator,
                    /* DropdownIndicator: () => null,
                          IndicatorSeparator: () => null, */
                  }}
                  options={filteredOptions}
                />
              </span>

              <span
                style={{
                  fontSize: '18px',
                  fontWeight: '500',
                  marginLeft: '30px',
                }}
              >
                Sort By :{' '}
              </span>
              <span className='col-2'>

                  <Select
                    placeholder='Select any option'
                    styles={customCityStyle}
                    value={
                      orderby ? options.find((ele) => ele.value === orderby) : ''
                    }
                    noOptionsMessage={() => 'loading...'}
                    onChange={(e) => handleSortby(e)}
                    components={{
                      DropdownIndicator,
                      /* DropdownIndicator: () => null,
                            IndicatorSeparator: () => null, */
                    }}
                    options={options}
                  />

              </span>
            </div>
          )}

          <div className='col-md-4 col-lg-3 pe-0 pe-md-2 ps-md-2 mt-2 new-vehicle-card border rounded-2 d-none d-sm-inline-block'>
            {/* <ProductFilters waitingData={waitingPeriod} /> */}
            {isDesktop && <NoSSRComponent waitingData={waitingPeriod} orderBy={orderby} filterBy={filterby} page={page} pageChanges={pageChanges} setPageChages={setPageChages} TriggerLoader={TriggerLoader} />}
          </div>
          <div className='col-md-8 col-lg-9 h-100 ps-2'>

            <div className='row mx-2 mx-sm-0'>
              {/* <div className='row ps-sm-2 mx-2 mx-sm-0'> */}
              {filterLoader ? (
                <div className='col-md-12 px-0 px-md-3 '>
                  <VehicleLoader />
                </div>
              )
                : allVehicleData.length > 0 && !vehicleLoading ? (
                  allVehicleData.map((vehicle, i) => (
                    <div
                      className='col-md-6 col-lg-4 px-0 px-md-2 my-2'
                      key={i}
                    >
                      <NewVehicleDetailsCard
                        vehicleData={vehicle}
                        vehicle
                        onGettingIdValue={(e) => onSelectIdValue(e, vehicle)}
                        getCheckBox={selectedId}
                        index={i}
                      // similiarproduct={true}
                      />
                      {/* <VehicleDetailsComponent
                      vehicleData={vehicle}
                      vehicle
                      onGettingIdValue={(e) => onSelectIdValue(e, vehicle)}
                      getCheckBox={selectedId}
                    /> */}
                    </div>
                  ))
                ) : allVehicleData.length === 0 && !filterLoader ? (
                  <div className='col-md-12 px-0 text-center px-md-2 mt-4 pt-2 h4'>
                    0 result found
                  </div>
                ) : null}

            </div>
            {/* </InfiniteScroll> */}
            {allVehicleData.length > 0 && !vehicleLoading ?
              <div className='text-center mt-4'>
                <Pagination total={filteredVehicles?.totalDocs} current={filteredVehicles?.page} itemRender={itemRender} showSizeChanger={false} defaultPageSize={9} onChange={(page) => { setPage(page); setPageChages(true) }} />
              </div>
              : null}

          </div>

          {openCompareModal && (
            <CompareModal
              getCompareArr={selectedArr}
              getCompareId={selectedId}
              onClickClose={onRemove}
            />
          )}
        </div>
        {allVehicleData.length > 0 && !vehicleLoading &&
          <div className='row'>
            {comparevehicles.length > 0 && <VehicleCompareCard type={2} />}

            <Popularimages />

            {faqList?.docs?.length > 0 && <FaqSection type={2} />}


            <RunningCostCalculator />

            {upcomingList?.docs?.length > 0 && <CommonParentSection title={'Upcoming Electric Vehicles'} type={'upcoming'}>
              {upcomingList?.docs?.length > 0 &&
                upcomingList?.docs?.length > 0 && !loading ? (
                <div className='position-relative' >
                  <button
                    className='scroll-btn scroll-btn-position d-none d-xl-block'
                    style={{ top: '11rem' }}
                    onClick={() => HandleScroll('left')}
                    aria-label="Scroll to upcoming vehicles on the left"
                  >
                    <AiOutlineLeft id='left-scroll' className='Right-left-icon' />
                  </button>
                  <div
                    className='d-flex justify-content-start align-items-center flex-row scroll-container'
                    id='upcoming-container'
                    style={{ height: '410px' }}
                  >
                    {upcomingList?.docs?.length > 0 &&
                      !loading &&
                      upcomingList.docs.map((vehicle) => (
                        <div
                          className=' d-inline-block me-3'
                          key={vehicle._id}
                        >
                          <HomeUpcomingVehicleCard
                            vehicleData={vehicle}
                            label={'Upcoming'}
                            subtype={"Upcoming Vehicles"}
                            type={2}
                          />
                        </div>
                      ))}
                  </div>
                  <button
                    className='scroll-btn scroll-btn-right-position d-none d-xl-block'
                    style={{ top: '11rem' }}
                    onClick={() => HandleScroll('right')}
                    aria-label="Scroll to upcoming vehicles on the right"
                  >
                    <AiOutlineRight id="right-scroll" className='Right-left-icon ' />
                  </button>
                </div>
              ) : (
                <div className='text-center color-d-gray py-5 fs-6'>
                  No Upcoming vehicles Found
                </div>
              )

              }
            </CommonParentSection>}

            <CommonParentSection title={'Latest Blog'} type={'blog'}>
              <BlogSection type={2} />
            </CommonParentSection>

            <CommonParentSection title={'Latest News'} type={'news'}>
              <NewsSectionCard type={2} />
            </CommonParentSection>
          </div>}
        {isMobile && (
          <div>
            <div className='filter-btns'>
              <button
                className='btn btn-success sort-btn'
                onClick={() => setOpenModal(true)}
              >
                <i className='px-2'>
                  <BiSort />
                </i>
                Sort
              </button>
              <button
                className='btn btn-success filter-btn'
                onClick={() => setOpenFilter(true)}
              >
                <i className='px-2 filter-icon'>
                  <FiFilter />
                </i>
                Filter
              </button>
            </div>
            <Modal
              centered
              isOpen={openModal}
              className='mobile-sort-modal'
              closeIcon={closeIcon}
              onClose={() => {
                setOpenModal(false);
              }}
            >
              <div className=' px-2'>
                <ModalHeader
                  toggle={() => {
                    setOpenModal(false);
                  }}
                >
                  Sort By
                </ModalHeader>
                <div className='sort-by modal-body gap-2 body-sec px-2 d-flex justify-content-between flex-column'>
                  <div className='py-2 d-flex align-items-center'>
                    {/* <input
                      type='radio'
                      value={1}
                      name='sort'
                      onChange={(e) => handleChange(e)}
                      checked={orderby === 1}
                      id='1'
                    /> */}
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={1}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 1}
                    />
                    <label htmlFor='1' className='px-2'>Low to high price</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={2}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 2}
                    />
                    <label htmlFor='2' className='px-2'>High to low price</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={3}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 3}
                    />
                    <label htmlFor='3' className='px-2'>Top speed</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={4}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 4}
                    />
                    <label htmlFor='4' className='px-2'>Range</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={5}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 5}
                    />
                    <label htmlFor='5' className='px-2'>Waiting period</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={6}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 6}
                    />
                    <label htmlFor='6' className='px-2'>Popular</label>
                  </div>
                  <div className='py-1 d-flex align-items-center'>
                    <Form.Check
                      name='sortBy'
                      type='checkbox'
                      id='two-wheeler'
                      value={7}
                      onChange={(e) => handleChange(e)}
                      checked={orderby == 7}
                    />
                    <label htmlFor='7' className='px-2'>Latest</label>
                  </div>
                </div>
              </div>
            </Modal>
            <div className='modal-div'>
              <Modal
                center
                isOpen={openfilter}
                closeIcon={closeIcon}
                onClose={() => {
                  setOpenFilter(false);
                }}
              // width="1000"
              >
                <ModalHeader
                  toggle={() => {
                    setOpenFilter(false);
                  }}
                >
                  Filter By
                </ModalHeader>
                <div className='modal-body body-sec '>
                  <MobileFilter
                    orderBy={orderby}
                    filterBy={filterby}
                    page={page}
                    pageChanges={pageChanges}
                    setPageChages={setPageChages}
                    setOpenFilter={setOpenFilter}
                    TriggerLoader={TriggerLoader}
                  />
                </div>
              </Modal>
            </div>

          </div>
        )}

      </section>
    </section >
  );
}
